import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import campaign from '@/utils/yagiprime/referralCampaign.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralCampaignHeadline',
  props: {
  /**
   * 「紹介した方 / 紹介された方」の対比図を出すか。
   * false のときは同じ位置にスロットの中身を出す（マイページは紹介の状況）。
   */
  showBenefit: {
    type: Boolean,
    required: false,
    default: true
  },
  /**
   * 吹き出しの文言を画面ごとに言い換えるときだけ渡す（1要素 = 1行）。
   * 既定は JSON の headline.badgeLines（紹介する側への訴求）。被紹介者の着地は
   * 「紹介すると」ではなく「紹介でアクセスした」立場なので差し替える。
   */
  badgeLines: {
    type: Array,
    required: false,
    default: null
  }
},
  setup(__props) {

const props = __props;

/**
 * 紹介キャンペーンの見出し（バッジ・タイトル・期間・特典の対比図）。
 *
 * シェア枠（ReferralShareOfferBox）から使う表示専用コンポーネント。共有ボタンや
 * 認証まわりの状態を持たないので、見出しだけを別ページ（マイページ・LP など）へ
 * 出したくなったときもそのまま置ける。
 *
 * 文言はすべて JSON カタログ（referralCampaign.json の headline）が正本。**期間の
 * 表記はリリース時に必ず更新する**（JSON 側のコメント参照）。
 */


const copy = campaign.headline

const badgeLines = computed(() => props.badgeLines || copy.badgeLines)

return { __sfc: true,props, copy, badgeLines }
}

})